<template>
  <div class="relative">
    <div class="w-full h-full absolute bg-white rounded-3xl statBox"></div>
    <div class="relative w-full h-full flex p-6 pt-4 justify-between">
      <div class="w-full">
        <div class="w-12 h-12 bg-white p-3 rounded-2xl">
        <img class="w-full h-full saturate-200 brightness-50" :src="icon" />
      </div>
      <div class="py-1"></div>
        <div class="title-color text-xl font-bold">{{ mainTitle }}</div>
        <div class="py-1"></div>
        <div class="grid grid-cols-2 w-full">
          <div>
            <div class="whitespace-nowrap">
              <span class="title-color text-3xl font-bold">{{ value1 }} </span
              >&nbsp;
              <span class="text-md">
                {{ unit }}
              </span>
            </div>
            <div class="py-1"></div>
            <div class="text-sm">{{ title1 }}</div>
          </div>
          <div>
            <div class="whitespace-nowrap">
              <span class="title-color text-3xl text-green-600 font-bold">{{ value2 }} </span
              >&nbsp;
              <span class="text-md">
                {{ unit }}
              </span>
            </div>
            <div class="py-1"></div>
            <div class="text-sm">{{ title2 }}</div>
          </div>
        </div>
        <!-- <div class="py-1"></div> -->
        <!-- <div class="text-sm">
          {{ bottomIndication }}
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PlatformStats',
  components: {},
  props: {
    icon: {
      type: String,
      default: '',
    },
    mainTitle: {
      type: String,
      default: '',
    },
    title1: {
      type: String,
      default: '',
    },
    title2: {
      type: String,
      default: '',
    },
    value1: {
      type: String,
      default: '',
    },
    value2: {
      type: String,
      default: '',
    },
    unit: {
      type: String,
      default: '',
    },
    bottomIndication: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {},
  computed: {},
})
</script>
